import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppShell from "./AppShell";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>,
);

// App installable : le service worker donne l'icône sur l'écran d'accueil,
// l'ouverture en plein écran et un démarrage possible sans réseau. Seulement
// sur la version en ligne : en développement il garderait en cache un code
// qu'on vient justement de modifier.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((erreur) => {
      console.warn('Service worker non enregistre :', erreur);
    });
  });
}
